import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerBackerResponse, UpdateBackerRequest } from './backer.types';

const useUpdateBacker = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const updateBacker = async ({ backer }: UpdateBackerRequest) => {
    const { data } = await BackerApi.put<ConsumerBackerResponse>('/consumer/backer', {
      backer,
    });
    return data;
  };

  return useMutation({
    mutationFn: updateBacker,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: backerKeys.consumer.backer.detail });
    },
  });
};

export { useUpdateBacker };
